import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
// import styles from "./BaseCanvas.module.scss";
import type { Canvas as CanvasType, FabricExtension, ManageObjectData } from "../types/canvasTypes";
import { findObjectExtension } from "../utils/canvasUtils";

const DEFAULT_EXTENSIONS: FabricExtension[] = [];

type BaseCanvasProps = {
  canvas?: CanvasType;
  extensions?: FabricExtension[];
};

export type BaseCanvasRef = {
  addObject: (data: ManageObjectData) => void;
  modifyObject: (data: ManageObjectData) => void;
  getCanvasRef: () => HTMLCanvasElement | null;
};

export const BaseCanvas = forwardRef<BaseCanvasRef, BaseCanvasProps>(
  ({ canvas, extensions = DEFAULT_EXTENSIONS }, ref) => {
    // To extend functionality create an extension and pass it here
    const [extensionsList] = useState(extensions);
    const canvasRef = useRef<HTMLCanvasElement | null>(null);

    useImperativeHandle(ref, () => ({
      addObject: ({ name, payload }: ManageObjectData) => {
        const extension = findObjectExtension(name, extensionsList);
        extension?.onAddObject({ canvas: canvas!, payload });
      },
      modifyObject: ({ name, payload }: ManageObjectData) => {
        const extension = findObjectExtension(name, extensionsList);
        extension?.onModifyObject({ canvas: canvas!, payload });
      },
      getCanvasRef: () => canvasRef.current,
    }));

    useEffect(() => {
      if (!canvas) return;

      extensionsList.forEach((extension) => extension.onInit?.(canvas));

      return () => {
        extensionsList.forEach((extension) => extension.onDestroy?.(canvas));
      };
    }, [canvas, extensionsList]);

    return <canvas ref={canvasRef} />;
  }
);
